const carouselWrapper = document.getElementById('carousel-wrapper');

let scrollAmount = 0;

function startCarousel() {
  setInterval(() => {
    scrollAmount += 1;
    if (scrollAmount >= carouselWrapper.scrollWidth - carouselWrapper.clientWidth) {
      scrollAmount = 0; // Reset to start
    }
    carouselWrapper.scrollTo({
      left: scrollAmount,
      behavior: 'smooth',
    });
  }, 50); // Adjust speed as needed
}

document.addEventListener('DOMContentLoaded', startCarousel);
